import React from 'react';
import { useLanguage } from '@/state/language/LanguageProvider';
import { EmptyState } from '@/components/ui/EmptyState';
import { Button } from '@/components/ui/Button';

export const ChangeManagementPage: React.FC = () => {
  const { t } = useLanguage();
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold text-[var(--color-secondary-text)]">{t('changeManagement.title')}</h1>
        <p className="mt-1 text-sm text-[var(--color-secondary-text)]">
          Manage organizational change initiatives
        </p>
      </div>
      
      <EmptyState
        title="Change Initiatives"
        count={0}
        message="No change initiatives created yet. Get started by creating your first change initiative."
        action={
          <Button disabled>
            Create Initiative
          </Button>
        }
      />
    </div>
  );
}; 


